<template>

  <div>
    <p class="text-headline-small mt-3">Note</p>
    <v-textarea label="" v-model="model.note"></v-textarea>
  </div>

  <div 
    v-if="props.show_timestamp"
    class="mb-5"
  >
    <p class="text-headline-small">Data</p>
    <date-time-input 
    v-model="model.timestamp" 
    />
  </div>


<div 
  v-if="props.show_start_end_observation_dates"
  class="mb-5"
>
    <p class="text-headline-small">Date</p>
    <p class="mt-2">Inizio</p>
    <date-time-input 
    v-model="model.observation_from" 
    :max="model.observation_to"
    title="Inizio"
    />
    
    <p class="mt-2">Fine</p>
    <date-time-input 
    v-model="model.observation_to" 
    :min="model.observation_from"
    title="Fine"
    />

  </div>




  

  <div>
    <p class="text-headline-small">Media</p>
    <files-browser v-if="model" :target_uuid="model.uuid" purpose="media" title="" :readonly="true" />
  </div>

  <!-- isReadOnly: {{ isReadOnly }} -->
</template>

<script setup>

import { ref, computed, onMounted,  inject } from "vue";

import FilesBrowser from '@/components/media/FilesBrowser.vue'
import DateTimeInput from '@/reports/components/DateTimeInput.vue'

const isFormReadOnly = ref(false) 


const props = defineProps({
    show_timestamp: {
        type: Boolean,
        default: () => true,
    },
    show_start_end_observation_dates: {
        type: Boolean,
        default: () => false,
    },
})


const model = defineModel()


onMounted(async () => {

  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
  isFormReadOnly.value = svf.isReadonly.value

})



</script>
